import React from 'react';
import { colors } from '../../styles/styles';

const NavigationButton = ({ onClick, isMobile, styles }) => {
    if (isMobile) {
        return (
            <button 
                onClick={onClick}
                style={styles.composePage.mobile.backButton}
            >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15 18L9 12L15 6" stroke={colors.textSecondary} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </button>
        );
    }

    return (
        <button 
            onClick={onClick}
            style={styles.composePage.desktop.closeButton}
        >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18M6 6L18 18" stroke={colors.textSecondary} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </button>
    );
};

export default NavigationButton; 